import React, { useContext } from 'react';

import AsideBox from 'Components/common/AsideBox';
import { ContentContext } from 'Components/hooks/context';
import FlatteningCurve from './FlatteningCurve';
import Headline from './Headline';
import LocaleLinks from './LocaleLinks';
import MethodologyLink from 'Components/common/MethodologyLink';
import RateMap from './RateMap';
import RegionShare from './RegionShare';
import ReutersReferrals from 'Components/common/ReutersReferrals';
import TopDailyCounts from './TopDailyCounts';
import TopDailyHeadline from './TopDailyHeadline';

const PageContent = (props) => {
  const { region, regionalCounts, globalStatistics, hasFetched, locales } = props;

  const content = useContext(ContentContext);

  const regionCases = regionalCounts.cases.filter(d => d.region === region);
  const regionDeaths = regionalCounts.deaths.filter(d => d.region === region);
  // This is necessary for dailyCounts right now
  regionCases.sort((a, b) => new Date(a.date) - new Date(b.date));
  regionDeaths.sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <article>
      <section>
        <LocaleLinks locales={locales} />
      </section>
      <section className='wide'>
        <Headline
          globalStatistics={globalStatistics}
          hasFetched={hasFetched}
        />
      </section>
      <div className='section-spacer' />
      <section className='wide'>
        <AsideBox
          title={content.common.about.title}
          source={content.common.about.smarttext}
          context={{ countries: Object.keys(globalStatistics.latestTotals.cases).length }}
        >
          <p className='readmore-link'><MethodologyLink>{content.common.about.methodologyLink}</MethodologyLink></p>
        </AsideBox>
      </section>
      <section>
        <TopDailyHeadline
          regionalCounts={{
            cases: regionCases,
            deaths: regionDeaths,
          }}
        />
        <TopDailyCounts
          globalStatistics={globalStatistics}
          counts={{
            cases: regionCases,
            deaths: regionDeaths,
          }}
        />
      </section>
      <section>
        {
          region !== 'oceania' && (
            <RegionShare
              counts={regionalCounts}
              endDates={globalStatistics.latestCompletedCounts}
            />
          )
        }
      </section>
      <section>
        <div className='col-12 col-lg-10 mx-auto px-0'>
          <ReutersReferrals />
        </div>
      </section>
      <section>
        <FlatteningCurve globalStatistics={globalStatistics} />
      </section>
      <div className='section-spacer' />
      <div className='section-spacer-internal' />
      <div className='container-fluid map-container'>
        <div className='row'>
          <div className='col-12 px-0'>
            <RateMap globalStatistics={globalStatistics} />
          </div>
        </div>
      </div>
    </article>
  );
};

export default PageContent;
